var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStorageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#EFF3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02012 4.61571L4.61548 6.02032L8.59534 10.0001L4.61548 13.9799L6.02012 15.3847L10.0002 11.4045L13.9798 15.3847L15.3847 13.9799L11.4049 10.0001L15.3847 6.02009L13.9798 4.61548L9.99998 8.59548L6.02012 4.61571Z",
    fill: "#A93300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorageError);
export default __webpack_public_path__ + "static/media/icon_storage_error.ec69a4987ca9be981db5dfece54ea411.svg";
export { ForwardRef as ReactComponent };